/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Savechanges1Inputs */

const en_savechanges1 = /** @type {(inputs: Savechanges1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Changes`)
};

const de_savechanges1 = /** @type {(inputs: Savechanges1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungen speichern`)
};

/**
* | output |
* | --- |
* | "Save Changes" |
*
* @param {Savechanges1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const savechanges1 = /** @type {((inputs?: Savechanges1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Savechanges1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_savechanges1(inputs)
	return de_savechanges1(inputs)
});
export { savechanges1 as "saveChanges" }